/**
 * @license
 * @copyright Copyright Motili Inc., 2019 All Rights Reserved
 */

import { useState, useMemo } from 'react';
import PropTypes from 'prop-types';
import debounce from 'lodash/debounce';
import * as logger from 'common/utils/Logger';
import Modal from './Modal';
import MotiliButton from '../../components-v2/buttons/MotiliButton';
import MotiliButtonContainer from '../buttons/MotiliButtonContainer';

export default function UpdateAppModal({ handleUpdate }) {
    const [busy, setBusy] = useState(false);

    const handleUpdateClick = useMemo(
        () =>
            debounce(async () => {
                setBusy(true);
                try {
                    await handleUpdate();
                } catch (error) {
                    logger.error('[UpdateAppModal] Update failed:', error, {
                        skipSentry: true,
                    });
                }
            }, 300),
        [handleUpdate]
    );

    return (
        <Modal
            controlId='updateAppModal-sw'
            headerStyles={{ fontSize: 32 }}
            header='Required Update'
            onCloseClick={handleUpdateClick}
            showClose={false}
            footer={
                <MotiliButtonContainer>
                    <MotiliButton
                        text='Update Now'
                        onClick={handleUpdateClick}
                        busy={busy}
                    />
                </MotiliButtonContainer>
            }
        >
            <div>Click Update Now to perform a Platform upgrade.</div>
        </Modal>
    );
}
UpdateAppModal.propTypes = {
    handleUpdate: PropTypes.func.isRequired,
};
